import React, { useEffect, useState } from 'react';
import Table from '../../../../../components/Table';
import {
  IOpenOrderStatusData,
  IOpenOrderStatusState
} from '../../../../../store/ducks/dashboard/types';
import { formatNumberTon } from '../../../../../utils/formatNumbers';
import { TableContainer } from './styles';
interface OpenOrderStatusTableDataSource {
  key: number;
  divisionProducts: string;
  totalDelivery: string;
  totalPending: string;
  totalRequested: string;
  totalShipment: string;
}

interface IOpenOrderStatusTableProps {
  openOrderStatusState: IOpenOrderStatusState;
}

const OpenOrderStatusTable: React.FC<IOpenOrderStatusTableProps> = ({
  openOrderStatusState
}) => {
  const [openOrderStatusData, setOpenOrderStatusData] = useState<
    OpenOrderStatusTableDataSource[]
  >([]);

  const updateOpenOrderData = () => {
    if (!openOrderStatusState.dashboard) {
      return;
    }

    const newOpenOrderStatusData = openOrderStatusState.dashboard.map(
      (item: IOpenOrderStatusData, idx: number) => {
        const {
          divisionProducts,
          totalDelivery,
          totalPending,
          totalRequested,
          totalShipment
        } = item;

        return {
          key: idx + 1,
          divisionProducts,
          totalDelivery,
          totalPending,
          totalRequested,
          totalShipment
        };
      }
    );

    setOpenOrderStatusData([...newOpenOrderStatusData]);
  };

  useEffect(() => {
    if (openOrderStatusData.length === 0 && !openOrderStatusState.error) {
      updateOpenOrderData();
    }
  }, [openOrderStatusState.dashboard]);

  const getTonNumberFormatted = (text: string): string => {
    text = text.replace(/,/g, '');

    if (!text || !Number(text)) {
      return ' - ';
    } else {
      return formatNumberTon(text);
    }
  };

  const getColumns = () => {
    const columns = [
      {
        title: 'Produtos',
        dataIndex: 'divisionProducts',
        render: (text: string) => <>{text}</>
      },
      {
        title: 'Solicitado',
        dataIndex: 'totalRequested',
        render: (text: string) => <>{getTonNumberFormatted(text)}</>
      },
      {
        title: 'Em remessa',
        dataIndex: 'totalDelivery',
        render: (text: string) => <>{getTonNumberFormatted(text)}</>
      },
      {
        title: 'Em carregamento',
        dataIndex: 'totalShipment',
        render: (text: string) => <>{getTonNumberFormatted(text)}</>
      },
      {
        title: 'Saldo',
        dataIndex: 'totalPending',
        render: (text: string) => <>{getTonNumberFormatted(text)}</>
      }
    ];

    return columns;
  };

  return (
    <TableContainer>
      <Table columns={getColumns()} data={openOrderStatusData} hasPagination />
    </TableContainer>
  );
};

export default OpenOrderStatusTable;
